/**
 * Frontend code for the STRL Searchable Checkboxes and STRL Searchable Radios
 */
document.addEventListener('facetwp-loaded', () => {
	initReset();
	initDropdownGroup();
	initSearchBoxes();
});

// Close dropdowns on choice
document.addEventListener('facetwp-refresh', () => {
	if (!FWP.soft_refresh) {
		const filterDropdowns = document.querySelectorAll('.filter-dropdown-group');

		filterDropdowns.forEach((dropdown) => {
			dropdown.style.opacity = 0.5; // Loading state
			dropdown.classList.remove('open');
		});
	}
	initDropdownGroup();
});

// Close dropdowns on outside click
document.addEventListener('click', (event) => {
	const filterDropdowns = document.querySelectorAll('.filter-dropdown-group');

	filterDropdowns.forEach((dropdown) => {
		const isClickInside = dropdown.contains(event.target);
		if (!isClickInside) {
			dropdown.classList.remove('open');
		}
	});
});

function initDropdownGroup() {
	const filterDropdownGroup = document.querySelectorAll('.filter-dropdown-group');
	let timeout = false;

	filterDropdownGroup.forEach((group) => {
		const selectLabel = group.querySelector('.filter-title .selected-value');
		const filterName = group.dataset.filterName;
		const selectedValue = FWP.facets[filterName];
		const filterTitle = group.querySelector('.filter-title');
		const dropdown = group.querySelector('.filter-dropdown');

		// Open dropdowns on filter title click
		filterTitle.addEventListener('click', (elem) => {
			// Ugly timeout fix to account for double FacetWP triggering
			if (!timeout) {
				group.classList.toggle('open');
				timeout = true;
				setTimeout(() => {
					timeout = false;
				}, 500);
			}
		});

		// Adjust placeholder on selection
		if (selectedValue.length) {
			let labels = [];
			selectedValue.forEach((selected) => {
				labels.push(
					document.querySelector('.facetwp-checkbox[data-value="' + selected + '"] .facetwp-display-value')
						.innerHTML
				);
			});
			selectLabel.innerHTML = labels.join(', ');
		} else {
			selectLabel.innerHTML = selectLabel.dataset.placeholder;
		}

		dropdown.style.opacity = 1; // Done loading
	});
}

function initReset() {
	// Reset specific filters
	const resetButtons = document.querySelectorAll('[data-reset-filter]');
	resetButtons.forEach((btn) => {
		btn.addEventListener('click', () => {
			const filterName = btn.dataset.resetFilter;
			FWP.reset(filterName);
		});
	});
}

function initSearchBoxes() {
	// Searchboxes logic inside filter dropdowns
	const searchboxes = document.querySelectorAll('[data-filter-searchbox]');
	searchboxes.forEach((search) => {
		const choices = search.parentElement.querySelectorAll('.facetwp-checkbox, .facetwp-radio');
		search.addEventListener('input', (e) => {
			const inputValue = e.target.value.toLowerCase().replace(' ', '-');
			choices.forEach((choice) => {
				if (!choice.dataset.value.includes(inputValue) && inputValue !== '') {
					choice.style.display = 'none';
				} else {
					choice.style.display = 'flex';
				}
			});
		});
	});
}
